import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'alt_hub';
export const route = 'alt_hub/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "alt_hub" */
/* webpackPrefetch: true */
'../components/AltHubPage')));